import { Base } from '@studiometa/js-toolkit';
import { nextTick } from '@studiometa/js-toolkit/utils';

/**
 * Stack component
 */
export default class Stack extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Stack',
    refs: ['items[]', 'placeholders[]'],
  };

  firstImageUrl = '';
  observer = null;
  activeIndex = 0;

  /**
   * Mounted
   */
  mounted() {
    nextTick(() => {
      if (this.$refs.items && this.$refs.items.length > 0) {
        this.firstImageUrl = this.$refs.items[0].dataset.optionUrl;
        this.swapImage(this.firstImageUrl);
        this.initObserver();

        this.$el.classList.remove('opacity-0');
      }
    });
  }

  /**
   *
   */
  initObserver() {
    const options = { threshold: 0.5 };
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          this.swapImage(entry.target.dataset.optionUrl);
        }
      }
    }, options);

    this.$refs.items.forEach((item) => observer.observe(item));
    this.observer = observer;
  }

  /**
   *
   */
  swapImage(url) {
    const current = this.$refs.placeholders[this.activeIndex];

    const nextIndex = this.activeIndex === 0 ? 1 : 0; // simple toggle
    const next = this.$refs.placeholders[nextIndex];
    const img = next.querySelector('img');

    const preload = new Image();
    preload.src = url;
    preload.addEventListener('load', () => {
      img.src = url;

      current.classList.add('opacity-0');
      next.classList.remove('opacity-0');

      this.activeIndex = nextIndex; // on bascule
    });
  }
}
